<p *ngFor="let alert of alerts">
    <ngb-alert insert-alert-icon [type]="alertType(alert)" (close)="removeAlert(alert)"><strong>{{alert.code}}</strong> {{alert.message}}</ngb-alert>
</p>
